import React, { useState } from "react";
import { BCNewOrderLine, BCNewOrderRequest } from "../../Interfaces/BCNewOrderRequest";
import NewServiceOrderGeneral from "./Components/NewServiceOrderGeneral";
import NewServiceOrderService from "./Components/NewServiceOrderService";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../Redux/hooks";
import { DataService } from "../../Services/DataService";
import { notification } from "antd";
import RouteLinks from "../../Router/RouteLinks";
import { store } from "../../Redux/store";
import { setSelectedOrder } from "../../Redux/Slices/appSlice";

enum NewOrderStep {
    GENERAL,
    SERVICE
}

const NewServiceOrder = () => {

    let navigate = useNavigate();

    const [currentStep, setCurrentStep] = useState<NewOrderStep>(NewOrderStep.GENERAL);
    const [request, setRequest] = useState<BCNewOrderRequest>();
    const [loading, setLoading] = useState(false);


    function onExit() {
        navigate(-1);
    }

    function onBackService() {
        setCurrentStep(NewOrderStep.GENERAL);
    }

    function onFinishGeneral(result: BCNewOrderRequest) {
        setRequest(result);
        setCurrentStep(NewOrderStep.SERVICE);
    }

    function onFinishService(lines: BCNewOrderLine[]) {
        if (request) {
            let help = { ...request }
            help.lines = lines;

            setLoading(true);
            DataService.addServiceOrder(help).then(res => {
                console.log("created", res);
                if (res.status === "loaded") {
                    store.dispatch(setSelectedOrder(res.payload));
                }
                navigate(`/${RouteLinks.service}`);
            }).catch(err => {
                notification.error({
                    description: err.error.response.data.Message,
                    message: "Versturen service order mislukt.",
                    duration: 8
                });

            }).finally(() => {
                setLoading(false);
            });
        }
    }


    function getCurrentScreen() {
        switch (currentStep) {
            case NewOrderStep.GENERAL: return (
                <NewServiceOrderGeneral onExit={onExit} onFinish={onFinishGeneral} request={request} />
            );
            case NewOrderStep.SERVICE: return (
                <NewServiceOrderService onExit={onExit} onFinish={onFinishService} onBack={onBackService} loading={loading} request={request} />
            )
        }
    }

    return (
        <div style={{ display: "flex", flex: 1, justifyContent: "center", alignItems: "center", flexDirection: "row", marginTop: 32 }}>
            {getCurrentScreen()}
        </div>

    );
};

export default NewServiceOrder;